export default __webpack_public_path__ + "static/media/01.2f89ec00.jpg";